//---- components ---------
//---- mixins -------------
//---- services -----------
import { ajaxService } from '@/app/services';
//---- other --------------
import store from '@/app/store/index.js'
import URL from '../common/URL.js';
//---- 3rd-parties --------

class KMOfflineService {

    isReplica() {
        return store.getters["kmOffline/isKMOffline"];
    }

    /**
     * Generate the kmOffline package if it doesn't already exist.
     */
    generateKMOfflinePackage(params) {
        return ajaxService.postData(URL.generateKMOfflinePackageUrl, params)
    }
    
    /**
     * Check if there are any project updates available on the server. 
     */
    async checkForUpdate() {
        return await ajaxService.post(URL.replicaCheckForUpdateUrl)
    }

    /**
     * Performs a replica synchronization or returns the current synchronization 
     * status if one is already running. 
     */
    async replicaSynchronize(confirmation) {
        try {
            return await ajaxService.postData(URL.replicaSynchronizeUrl, confirmation ? {firstSynchronizationConfirmation: confirmation} : null)
        }
        catch (e) {
            if (e.response.data.key == "admin.replica.sync.not-authenticated-online")
                store.dispatch("kmOffline/onlineAuthenticated", false);
        }
    }

    /**
     * Validate the solo password entered by the user. This checks the password complexity. 
     */
    async soloRegistrationValidatePwd(params) {
      try {
        return await ajaxService.postData(URL.soloRegistrationValidatePwdUrl, params)
      }
      catch {
        // ignore error as it will end up in redirection
      }
    }

    //-------------------------------------------------------------------------
    // connectivity status

    /**
     * Check connectivity and updates the vuex status with it.
     * 
     * If the user is logged in, it will call hServiceConnectivity.jsp to get
     * the value without influencing the session timeout.
     * 
     * If the user is logged out, it will call replicaCheckConnectivity.action.
     * This is a more direct way of checking.
     * 
     * @intervalHint is a hint for the backend so it knows at which frequency to 
     *               check for connectivity. This is only useful when logged in 
     *               and when using hServiceConnectivity.jsp.
     */
    async checkConnectivity(intervalHint) {

      try {
        let isLoggedIn = store.getters["auth/loggedIn"];
        if (!isLoggedIn) {
            // this check will update the value automatically in vuex
              return await ajaxService.post(URL.replicaCheckConnectivityUrl)
        }

        // if we're not logged in, make a "passive" check
        let url = store.getters["backendUrl"].replace(/\/[^/]+?$/, "/hServiceConnectivity.jsp?intervalHint=" + (intervalHint || "15000"));
        let response = await ajaxService.get(url);
        if (response?.data && Object.keys(response.data).length != 0) {
            this.updateVuexConnectivityInfo(response?.data);
            return;
        }

        // if the response doesn't contain anything (this is because the class has not been initialized yet on the backend)
        console.log("empty response from hServiceConnectivity.jsp, calling checkForUpdate");
        const resp = await this.checkForUpdate();
        console.log(resp);
        if (resp?.key == "session-expired") {
            return await ajaxService.post(URL.replicaCheckConnectivityUrl)
        }
      }
      catch { // ignore 
      }
    }
    
    /**
     * hServiceConnectivityResponse should contain the following:
     * 
     *    { 
     *        internetConnectivity: true/false, 
     *        hServiceConnectivity: true/false 
     *    }
     */
    updateVuexConnectivityInfo(hServiceConnectivityResponse) {
        const connectivity = {
            browserConnectivity: navigator.onLine,
            backendInternetConnectivity: hServiceConnectivityResponse?.internetConnectivity || false,
            hServiceConnectivity: hServiceConnectivityResponse?.hServiceConnectivity || false,
        }
        store.dispatch("kmOffline/updateConnectedState", connectivity);
    }
}

export default new KMOfflineService();
